import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Theme,
  IconButton,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  CustomMenu,
  CustomMenuItem,
  StyledTableRow,
} from "../../../../styles/Shipmentstyles";
import { ProjectRequest } from "../../../../models/Project/Project";
import AppTableHeaderCell from "../../common/pages/AppTableHeaderCell";
import AppTableRowCell from "../../common/pages/AppTableRowCell";
import { SortType } from "../../../../models/SortType";
import AppTablePagenation from "../../common/pages/AppTablePagenation";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

interface ProjectTableProp {
  project: ProjectRequest[];
  // onSortChange: (column: string) => void;
  limit: number;
  page_no: number;
  total_pages: number;
  total_count: number;
  sortBy: string;
  sortType: SortType;
  onSortChange: (column: string, sortType: SortType) => void;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onRowsPerPageChange: (limit: number) => void;
  handleApprove: (id: number) => void;
  handleReject: (id: number) => void;
}

const ProjectTable = ({
  project,
  page_no,
  limit,
  total_pages,
  total_count,
  sortBy,
  sortType,
  onSortChange,
  onPageChange,
  onRowsPerPageChange,
  handleApprove,
  handleReject,
}: ProjectTableProp) => {
  const navigate = useNavigate();
  const theme = useTheme<Theme>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedId, setSelectedId] = useState<number | undefined>();
  const isOpen = Boolean(anchorEl);

  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    requestId: number
  ) => {
    setSelectedId(requestId);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedId(undefined);
  };

  const handleRejectLocal = () => {
    setAnchorEl(null);
    if (selectedId) handleReject(selectedId);
  };

  const handleApproveLocal = () => {
    setAnchorEl(null);
    if (selectedId) handleApprove(selectedId);
  };

  const handleRowsChange = (value: number) => {
    onPageChange(null, 1);
    onRowsPerPageChange(value);
  };

  const changeMinutesIntoHoursAndMins = (inputInt: number) => {
    if (inputInt > 0) {
      const hours = Math.trunc(inputInt / 60);
      const mins = Math.trunc(inputInt % 60);

      if (mins === 0) {
        return "--";
      } else if (hours === 0) {
        return `${mins} min`;
      } else {
        return `${hours} hr ${mins} min`;
      }
    } else {
      return "-";
    }
  };

  return (
    <>
      <Paper sx={{ marginTop: "0.6rem" }}>
        <TableContainer sx={{ maxHeight: window.innerHeight - 340 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <AppTableHeaderCell
                  sx={{
                    textAlign: "center",
                    fontSize: 12,
                    position: "sticky",
                    left: 0,
                    zIndex: 12,
                  }}
                  sortColumn={"id"}
                  sortBy={sortBy}
                  sortDirection={sortType}
                  onSortChange={onSortChange}
                  title="ID"
                />
                <AppTableHeaderCell
                  sx={{
                    textAlign: "center",
                    fontSize: 12,
                    position: "sticky",
                    left: 52,
                    zIndex: 12,
                    boxShadow: "10px 0 20px -12px rgba(115,115,115,0.3);",
                  }}
                  sortColumn={"order_id"}
                  sortBy={sortBy}
                  sortDirection={sortType}
                  onSortChange={onSortChange}
                  title="Order ID"
                />
                <AppTableHeaderCell title="Requestor Name" />
                <AppTableHeaderCell title="Brand Name" />
                <AppTableHeaderCell title="Request Status" />
                <AppTableHeaderCell title="SCR Status" />
                <AppTableHeaderCell title="Client POC" />
                <AppTableHeaderCell title="Contact Number(POC)" />
                <AppTableHeaderCell title="Company Name" />
                <AppTableHeaderCell title="TAT" />
                <AppTableHeaderCell
                  title="Delivery Date"
                  sortColumn={"delivery_date"}
                  sortBy={sortBy}
                  sortDirection={sortType}
                  onSortChange={onSortChange}
                />
                <AppTableHeaderCell title="Delivery Flexible" />
                <AppTableHeaderCell title="Order Info" />
                <AppTableHeaderCell title="Mockup Status" />
                <AppTableHeaderCell title="Order Type" />
                <AppTableHeaderCell title="Payment Status" />
                <AppTableHeaderCell title="Shipment Mode" />
                <AppTableHeaderCell title="Shipment Type" />
                <AppTableHeaderCell title="DIY Redemption" />
                <AppTableHeaderCell
                  title="Closed On"
                  sortColumn={"closed_on"}
                  sortBy={sortBy}
                  sortDirection={sortType}
                  onSortChange={onSortChange}
                />
                <AppTableHeaderCell title="Closer Name" />
                <AppTableHeaderCell title="Cancel Reason" />
                <AppTableHeaderCell
                  title="Created Date"
                  sortColumn={"created_date"}
                  sortBy={sortBy}
                  sortDirection={sortType}
                  onSortChange={onSortChange}
                />
                <AppTableHeaderCell
                  title="Modified Date"
                  sortColumn={"modified_date"}
                  sortBy={sortBy}
                  sortDirection={sortType}
                  onSortChange={onSortChange}
                />
                <AppTableHeaderCell
                  sx={{
                    textAlign: "center",
                    fontSize: 12,
                    position: "sticky",
                    right: 0,
                    zIndex: 10,
                    backgroundColor: `${theme.palette.background.paper}`,
                  }}
                  title="Actions"
                />
              </TableRow>
            </TableHead>
            <TableBody>
              {project.map((project: ProjectRequest) => (
                <StyledTableRow key={project.id}>
                  <AppTableRowCell
                    sx={{
                      textAlign: "center",
                      fontSize: 12,
                      position: "sticky",
                      left: 0,
                      zIndex: 10,
                      backgroundColor: `${theme.palette.background.paper}`,
                    }}
                  >
                    {project.id}
                  </AppTableRowCell>
                  <AppTableRowCell
                    sx={{
                      textAlign: "center",
                      fontSize: 12,
                      position: "sticky",
                      left: 52,
                      zIndex: 10,
                      boxShadow: "10px 0 20px -12px rgba(115,115,115,0.3)",
                      backgroundColor: `${theme.palette.background.paper}`,
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() =>
                      navigate(`/orders/add-orders?orderId=${project.order_id}`)
                    }
                  >
                    {project.order_id}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.requestor_name || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>{project.brand_name}</AppTableRowCell>
                  <AppTableRowCell>
                    {project.status_label || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.stock_check_request_status || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>{project.client_poc}</AppTableRowCell>
                  <AppTableRowCell>
                    {project.client_poc_contact_no}
                  </AppTableRowCell>
                  <AppTableRowCell>{project.company_name}</AppTableRowCell>
                  <AppTableRowCell>
                    {project.tat
                      ? changeMinutesIntoHoursAndMins(Number(project.tat))
                      : "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.delivery_date === null ||
                    project.delivery_date === undefined
                      ? "-"
                      : dayjs(project.delivery_date).format("DD/MM/YYYY")}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.is_delivery_date_flexible === 1
                      ? "Yes"
                      : project.is_delivery_date_flexible === 0
                      ? "No"
                      : "-"}
                  </AppTableRowCell>
                  <AppTableRowCell
                    sx={{
                      maxWidth: "250px",
                      wordWrap: "break-word",
                      overflow: "hidden",
                      whiteSpace: "normal",
                    }}
                  >
                    {project.order_additional_info || ""}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.mockup_status_label || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.order_type_label || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.payment_status_label || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.shipment_mode_label || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.shipping_type_label || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.is_diy_redemption != null
                      ? project.is_diy_redemption === 1
                        ? "Yes"
                        : "No"
                      : "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.closed_on === null || undefined
                      ? "-"
                      : new Date(project.closed_on).toLocaleDateString(
                          "en-GB",
                          {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          }
                        )}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {project.closer_name || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell minWidth="80px">
                    {project.cancel_reason || ""}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {new Date(project.created_date).toLocaleDateString(
                      "en-GB",
                      {
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      }
                    )}
                  </AppTableRowCell>
                  <AppTableRowCell>
                    {new Date(project.modified_date).toLocaleDateString(
                      "en-GB",
                      {
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      }
                    )}
                  </AppTableRowCell>
                  <AppTableRowCell
                    sx={{
                      textAlign: "center",
                      fontSize: 12,
                      width: "10%",
                      position: "sticky",
                      right: 0,
                      zIndex: 8,
                      backgroundColor: `${theme.palette.background.paper}`,
                    }}
                  >
                    {project.status === 1 ? (
                      <>
                        <IconButton
                          onClick={(event) =>
                            handleMenuClick(event, project.id)
                          }
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <CustomMenu
                          sx={{ fontSize: "14px", marginTop: 3 }}
                          anchorEl={anchorEl}
                          onClose={handleMenuClose}
                          open={isOpen}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <CustomMenuItem
                            sx={{ fontSize: "14px" }}
                            onClick={() => handleApproveLocal()}
                          >
                            Approve
                          </CustomMenuItem>
                          <CustomMenuItem
                            sx={{ fontSize: "14px" }}
                            onClick={() => handleRejectLocal()}
                          >
                            Reject
                          </CustomMenuItem>
                        </CustomMenu>
                      </>
                    ) : (
                      "-"
                    )}
                  </AppTableRowCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <AppTablePagenation
          fontSize="12px"
          pageNo={page_no}
          limit={limit}
          totalCount={total_count}
          onPageChange={onPageChange}
          handleRowsChange={handleRowsChange}
        />
      </Paper>
    </>
  );
};

export default ProjectTable;
